import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import apiClient, { API_ENDPOINTS, clearAuthData, getUserInfoSync } from '../../config/api'
import logo from '../../assets/logo.jpeg'

const TopBar = ({ onToggleSidebar, setActiveScreen }) => {
  const navigate = useNavigate()
  const userInfo = getUserInfoSync()
  const [pendingRequestsCount, setPendingRequestsCount] = useState(0)

  // Get user display name
  const getUserDisplayName = () => {
    if (userInfo?.employee_name) return userInfo.employee_name
    if (userInfo?.full_name) return userInfo.full_name
    if (userInfo?.first_name && userInfo?.last_name) return `${userInfo.first_name} ${userInfo.last_name}`
    if (userInfo?.username) return userInfo.username
    if (userInfo?.email) return userInfo.email.split('@')[0]
    return 'User'
  }

  const handleProfileClick = (e) => {
    e.preventDefault()
    if (setActiveScreen) {
      setActiveScreen('profile')
    }
  }

  const handleToggleClick = (e) => {
    e.preventDefault()
    if (onToggleSidebar) {
      onToggleSidebar()
    }
  }

  const handleLogout = (e) => {
    e.preventDefault()
    clearAuthData()
    navigate('/login')
  }

  const handleNotificationClick = (e) => {
    e.preventDefault()
    e.stopPropagation()
    if (setActiveScreen && pendingRequestsCount > 0) {
      setActiveScreen('branch-requests')
      // Close the dropdown manually
      const dropdown = e.target.closest('.dropdown')
      if (dropdown) {
        const bsDropdown = window.bootstrap?.Dropdown?.getInstance(dropdown.querySelector('[data-bs-toggle="dropdown"]'))
        if (bsDropdown) {
          bsDropdown.hide()
        }
      }
    }
  }

  useEffect(() => {
    const fetchPendingRequests = async () => {
      try {
        const response = await apiClient.get(API_ENDPOINTS.STOCK_TRANSFERS)
        const movements = response.data || []
        
        // Filter for pending requests (excluding warehouse_to_warehouse and branch_to_branch)
        const pendingCount = movements.filter(movement => {
          const status = (movement.status || '').toLowerCase()
          return status === 'pending' && 
                 movement.transfer_type !== 'warehouse_to_warehouse' && 
                 movement.transfer_type !== 'branch_to_branch'
        }).length
        
        setPendingRequestsCount(pendingCount)
      } catch (err) {
        console.error('Failed to fetch pending requests:', err)
        // Don't show error to user, just keep count at 0
        setPendingRequestsCount(0)
      }
    }

    // Fetch immediately
    fetchPendingRequests()

    // Refresh every 30 seconds
    const interval = setInterval(fetchPendingRequests, 30000)

    return () => clearInterval(interval)
  }, [])

  return (
<header id="header" className="header fixed-top d-flex align-items-center">
  <div className="d-flex align-items-center justify-content-between">
    <a href="index.html" className="logo d-flex align-items-center">
      <img src={logo} alt="Logo" />
      <span className="d-none d-lg-block">Decor Masters</span>
    </a>
    <i className="bi bi-list toggle-sidebar-btn" onClick={handleToggleClick} style={{ cursor: 'pointer' }} />
  </div>{/* End Logo */}
 
  <nav className="header-nav ms-auto">
    <ul className="d-flex align-items-center">
      <li className="nav-item d-block d-lg-none">
        <a className="nav-link nav-icon search-bar-toggle " href="#">
          <i className="bi bi-search" />
        </a>
      </li>{/* End Search Icon*/}
      <li className="nav-item dropdown">
        <a 
          className="nav-link nav-icon" 
          href="#" 
          data-bs-toggle="dropdown"
        >
          <i className="bi bi-bell" />
          {pendingRequestsCount > 0 && (
            <span className="badge bg-primary badge-number">{pendingRequestsCount}</span>
          )}
        </a>{/* End Notification Icon */}
        <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow notifications">
          <li className="dropdown-header">
            {pendingRequestsCount > 0 ? (
              <>
                You have {pendingRequestsCount} pending request{pendingRequestsCount !== 1 ? 's' : ''}
                <a href="#" onClick={handleNotificationClick}><span className="badge rounded-pill bg-primary p-2 ms-2">View all</span></a>
              </>
            ) : (
              'No pending requests'
            )}
          </li>
          {pendingRequestsCount > 0 && (
            <>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li className="notification-item" onClick={handleNotificationClick} style={{ cursor: 'pointer' }}>
                <i className="bi bi-clipboard-check text-warning" />
                <div>
                  <h4>Branch Stock Requests</h4>
                  <p>You have {pendingRequestsCount} pending request{pendingRequestsCount !== 1 ? 's' : ''} waiting for approval</p>
                  <p>Click to view</p>
                </div>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li className="dropdown-footer">
                <a href="#" onClick={handleNotificationClick}>View all requests</a>
              </li>
            </>
          )}
        </ul>{/* End Notification Dropdown Items */}
      </li>{/* End Notification Nav */}
   
      <li className="nav-item dropdown pe-3">
        <a className="nav-link nav-profile d-flex align-items-center pe-0" href="#" data-bs-toggle="dropdown">
          <img src="assets/img/profile-img.jpg" alt="Profile" className="rounded-circle" />
          <span className="d-none d-md-block dropdown-toggle ps-2">{getUserDisplayName()}</span>
        </a>{/* End Profile Iamge Icon */}
        <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
          <li className="dropdown-header">
            <h6>{getUserDisplayName()}</h6>
            <span>{userInfo?.role_display || 'User'}</span>
          </li>
          <li>
            <hr className="dropdown-divider" />
          </li>
          <li>
            <a className="dropdown-item d-flex align-items-center" href="#" onClick={handleProfileClick} style={{ cursor: 'pointer' }}>
              <i className="bi bi-person" />
              <span>My Profile</span>
            </a>
          </li>
          <li>
            <hr className="dropdown-divider" />
          </li>
          <li>
            <a className="dropdown-item d-flex align-items-center" href="#" onClick={handleLogout} style={{ cursor: 'pointer' }}>
              <i className="bi bi-box-arrow-right" />
              <span>Sign Out</span>
            </a>
          </li>
        </ul>{/* End Profile Dropdown Items */}
      </li>{/* End Profile Nav */}
    </ul>
  </nav>{/* End Icons Navigation */}
</header>

  )
}

export default TopBar